import React, { useEffect, useRef, useState } from "react";
import { createMeeting, getToken, validateMeeting } from "../../api";
import ConfirmBox from "../ConfirmBox";
import { toast } from "react-toastify";
import { Constants, useMediaDevice, createCameraVideoTrack, createMicrophoneAudioTrack } from "@videosdk.live/react-sdk";
import useMediaStream from "../../hooks/useMediaStream";
import useIsMobile from "../../hooks/useIsMobile";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import test_sound from '../../sounds/test_sound.wav'
import { VirtualBackgroundProcessor, VideoSDKNoiseSuppressor } from "@videosdk.live/videosdk-media-processor-web";
import { backgroundImageUrls } from "../../utils/background";
import novirtualbackground from '../../images/novirtualbackground.png';
import { useSiteContext } from "../../context/SiteContext";
import { useNavigate } from "react-router-dom";
import * as meetingServices from "../../services/meetingServices";
import * as virtualBackgroundServices from "../../services/virtualBackgroundServices";
import logger from '../../utils/logger';

export function JoiningScreenNew({
  participantName,
  setParticipantName,
  setMeetingId,
  meetingId,
  setToken,
  setMicOn,
  setWebcamOn,
  onClickStartMeeting,
  customAudioStream,
  setCustomAudioStream,
  setCustomVideoStream,
  micOn,
  webcamOn,
  joiningToken,
  setJoiningToken,
}) {
  const {
    isAuthenticated,
    user,
    setMeetingRole,
    meetingRole,
    setMeetingSettings,
    meetingSettings,
    customMeetingName,
    setCustomMeetingName,
  } = useSiteContext();
  const navigate = useNavigate();
  const videoProcessor = new VirtualBackgroundProcessor();

  const {
    selectedWebcam,
    selectedMic,
    setSelectedMic,
    setSelectedWebcam,
    setSelectedSpeaker,
    selectedSpeaker,
    isCameraPermissionAllowed,
    isMicrophonePermissionAllowed,
    setIsCameraPermissionAllowed,
    setIsMicrophonePermissionAllowed,
    selectedBackground,
    setSelectedBackground,
    blurEnabled,
    setBlurEnabled,
    virtualBackgroundOn,
    setVirtualBackgroundOn,
  } = useMeetingAppContext();

  const isMobile = useIsMobile();
  const [roomName, setRoomName] = useState(null);
  const [userName, setUserName] = useState(participantName);
  const [selectedRole, setSelectedRole] = useState("Participant");
  const [dlgMuted, setDlgMuted] = useState(false);
  const [dlgDevices, setDlgDevices] = useState(false);
  const [didDeviceChange, setDidDeviceChange] = useState(false);
  const [testSpeaker, setTestSpeaker] = useState(false);
  const [showVideoOption, setShowVideoOption] = useState(false);
  const [showAudioOption, setShowAudioOption] = useState(false);
  const [showSpeakerOption, setShowSpeakerOption] = useState(false);
  const [showMicTest, setShowMicTest] = useState(false);
  const [showVirtualBackgroundModal, setShowVirtualBackgroundModal] =
    useState(false);
  const [customBackgrounds, setCustomBackgrounds] = useState([]);
  const [uploadingBackground, setUploadingBackground] = useState(false);
  const [showImageSizeInfoDialog, setShowImageSizeInfoDialog] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [backgroundToDelete, setBackgroundToDelete] = useState(null);
  const fileInputRef = useRef(null);
  const [passwordDigits, setPasswordDigits] = useState(["", "", "", ""]);
  const [passwordError, setPasswordError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState({
    camera: false,
    microphone: false,
  });
  const passwordInputRefs = useRef([]);

  // Mic test functionality states
  const [audioProgress, setAudioProgress] = useState(0);
  const [recordingProgress, setRecordingProgress] = useState(0);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [recordingDuration, setRecordingDuration] = useState(0);
  const [volume, setVolume] = useState(null);
  const [audio, setAudio] = useState(null);
  const [{ webcams, mics, speakers }, setDevices] = useState({
    webcams: [],
    mics: [],
    speakers: [],
  });

  const { getVideoTrack, getAudioTrack } = useMediaStream();
  const noiseProcessorRef = useRef(null);
  const {
    checkPermissions,
    getCameras,
    getMicrophones,
    requestPermission,
    getPlaybackDevices,
  } = useMediaDevice({ onDeviceChanged });

  const [audioTrack, setAudioTrack] = useState(null);
  const [videoTrack, setVideoTrack] = useState(null);

  const videoPlayerRef = useRef();
  const audioPlayerRef = useRef();
  const videoTrackRef = useRef();
  const audioTrackRef = useRef();
  const audioAnalyserIntervalRef = useRef();
  const permissonAvaialble = useRef();
  const webcamRef = useRef();
  const micRef = useRef();

  // Mic test functionality refs
  const intervalRef = useRef();
  const mediaRecorder = useRef(null);
  const [showVirtualBackground, setShowVirtualBackground] = useState(
    virtualBackgroundOn || selectedBackground !== null
  );
  const [copiedRoomName, setCopiedRoomName] = useState(false);

  useEffect(() => {
    webcamRef.current = webcamOn;
  }, [webcamOn]);

  useEffect(() => {
    micRef.current = micOn;
    setRecordingStatus("recording");
  }, [micOn]);

  useEffect(() => {
    permissonAvaialble.current = {
      isCameraPermissionAllowed,
      isMicrophonePermissionAllowed,
    };
  }, [isCameraPermissionAllowed, isMicrophonePermissionAllowed]);

  useEffect(() => {
    if (micOn) {
      audioTrackRef.current = audioTrack;
      startMuteListener();
    } else {
      setVolume(0);
    }
  }, [micOn, audioTrack]);

  useEffect(() => {
    if (micOn) {
      if (audioTrackRef.current && audioTrackRef.current !== audioTrack) {
        audioTrackRef.current.stop();
      }

      audioTrackRef.current = audioTrack;

      if (audioTrack) {
        const audioSrcObject = new MediaStream([audioTrack]);
        if (audioPlayerRef.current) {
          audioPlayerRef.current.srcObject = audioSrcObject;
          audioPlayerRef.current
            .play()
            .catch((error) => logger("log", "audio play error", error));
        }
      } else {
        if (audioPlayerRef.current) {
          audioPlayerRef.current.srcObject = null;
        }
      }
    }
  }, [micOn, audioTrack]);

  useEffect(() => {
    if (webcamOn) {
      if (videoTrackRef.current && videoTrackRef.current !== videoTrack) {
        videoTrackRef.current.stop();
      }

      videoTrackRef.current = videoTrack;

      var isPlaying =
        videoPlayerRef.current.currentTime > 0 &&
        !videoPlayerRef.current.paused &&
        !videoPlayerRef.current.ended &&
        videoPlayerRef.current.readyState >
        videoPlayerRef.current.HAVE_CURRENT_DATA;

      if (videoTrack) {
        const videoSrcObject = new MediaStream([videoTrack]);

        if (videoPlayerRef.current) {
          videoPlayerRef.current.srcObject = videoSrcObject;
          if (videoPlayerRef.current.pause && !isPlaying) {
            videoPlayerRef.current
              .play()
              .catch((error) => logger("log", "error", error));
          }
        }
      } else {
        if (videoPlayerRef.current) {
          videoPlayerRef.current.srcObject = null;
        }
      }
    }
  }, [webcamOn, videoTrack]);

  useEffect(() => {
    getCameraDevices();
  }, [isCameraPermissionAllowed]);

  useEffect(() => {
    getAudioDevices();
  }, [isMicrophonePermissionAllowed]);

  useEffect(() => {
    checkMediaPermission();
    return () => {
      // Cleanup noise processor on unmount
      if (noiseProcessorRef.current) {
        try {
          if (noiseProcessorRef.current.stopProcessing) {
            noiseProcessorRef.current.stopProcessing();
          }
        } catch (error) {
          // Ignore errors during cleanup
          logger("log", "Error stopping noise processor on unmount:", error);
        }
        noiseProcessorRef.current = null;
      }
    };
  }, []);

  // Monitor permission changes
  useEffect(() => {
    checkPermissionStatus();
  }, [isCameraPermissionAllowed, isMicrophonePermissionAllowed]);

  // Disable media for webinar participants when settings load
  useEffect(() => {
    if (
      meetingSettings?.roomType === "Webinar" &&
      !["moderator", "co-host", "speaker"].includes(meetingRole)
    ) {
      // Turn off mic and camera if they're on
      if (micOn) {
        const audioTrack = audioTrackRef.current;
        if (audioTrack) {
          audioTrack.stop();
          setAudioTrack(null);
          setCustomAudioStream(null);
          setMicOn(false);
        }
      }
      if (webcamOn) {
        const videoTrack = videoTrackRef.current;
        if (videoTrack) {
          videoTrack.stop();
          setVideoTrack(null);
          setCustomVideoStream(null);
          setWebcamOn(false);
        }
      }
    }
  }, [meetingSettings, meetingRole]);

  // read params of url
  useEffect(() => {
    // const pathname = window.location.pathname;
    // const roomName = pathname.split('/').pop();
    // checkValidMeeting(roomName);
    if (meetingSettings) {
      setRoomName(meetingSettings.roomName);
    }
  }, [isAuthenticated]);

  // Set default meeting name for moderators in Meeting and Webinar type rooms
  useEffect(() => {
    if (
      meetingSettings &&
      (meetingSettings.roomType === "Meeting" ||
        meetingSettings.roomType === "Webinar") &&
      ["moderator", "co-host", "host"].includes(meetingRole) &&
      user &&
      (!customMeetingName || customMeetingName.trim() === "")
    ) {
      // Get owner's first name - try different possible property names
      let ownerFirstName = "User";

      // Try to get from meetingSettings first (owner of the meeting)
      if (meetingSettings.ownerFirstName) {
        ownerFirstName = meetingSettings.ownerFirstName;
      } else if (meetingSettings.owner?.firstName) {
        ownerFirstName = meetingSettings.owner.firstName;
      } else if (meetingSettings.owner?.first_name) {
        ownerFirstName = meetingSettings.owner.first_name;
      } else if (meetingSettings.owner?.name) {
        ownerFirstName = meetingSettings.owner.name.split(" ")[0];
      }
      // Fallback to current user if no owner info in meetingSettings
      else if (user.firstName) {
        ownerFirstName = user.firstName;
      } else if (user.first_name) {
        ownerFirstName = user.first_name;
      } else if (user.name) {
        ownerFirstName = user.name.split(" ")[0];
      }

      // Format date as m-d-yy (e.g., "11-16-24")
      const now = new Date();
      const month = (now.getMonth() + 1).toString(); // getMonth() returns 0-11, add 1, then string
      const day = now.getDate().toString();
      const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
      const formattedDate = `${month}-${day}-${year}`;

      // Set default meeting name based on room type
      const roomTypeLabel =
        meetingSettings.roomType === "Webinar" ? "Webinar" : "Meeting";
      const defaultMeetingName = `${ownerFirstName} ${roomTypeLabel} on ${formattedDate}`;
      setCustomMeetingName(defaultMeetingName);
    }
  }, [
    meetingSettings,
    meetingRole,
    user,
    customMeetingName,
    setCustomMeetingName,
  ]);

  const checkValidMeeting = async (roomName) => {
    try {
      const response = await meetingServices.getMeetingByName(roomName);
      const meeting = response.meeting;
      if (meeting) {
        meeting.scheduledStartTime = meeting.scheduledStartTime.replace(
          ".000Z",
          ""
        );
        if (
          meetingRole === "moderator" ||
          meetingRole === "co-host" ||
          meetingRole === "speaker"
        ) {
          setMeetingSettings(meeting);
        } else {
          setMeetingSettings(meeting);
        }
        setRoomName(meeting.roomName);
        setMeetingRole(meeting.role || "participant");
        setMeetingId(meeting.roomId);
        logger("log", "meetingRole", meeting.role);
        const allowGuest = localStorage.getItem("allowguest");
        if (!isAuthenticated && !allowGuest) {
          localStorage.setItem("roomId", roomName);
          navigate(`/login`);
        } else {
          const jointokenresp = await meetingServices.getJoiningToken({
            roomId: meeting.roomId,
          });
          if (jointokenresp.token) {
            setJoiningToken(jointokenresp.token);
          }
          localStorage.removeItem("roomId");
          localStorage.removeItem("allowguest");
        }
      } else {
        // toast("Meeting not found", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: true,
        //     closeButton: false,
        //     pauseOnHover: true,
        // });
        navigate(`/meeting-not-found`);
      }
    } catch (error) {
      logger("log", "Error in checkValidMeeting", error);
    }
  };

  const _toggleWebcam = () => {
    // Prevent webinar participants from toggling camera
    if (
      meetingSettings?.roomType === "Webinar" &&
      !["moderator", "co-host", "speaker"].includes(meetingRole)
    ) {
      return;
    }

    const videoTrack = videoTrackRef.current;

    if (webcamOn) {
      if (videoTrack) {
        videoTrack.stop();
        setVideoTrack(null);
        setCustomVideoStream(null);
        setWebcamOn(false);
      }
    } else {
      getDefaultMediaTracks({ mic: false, webcam: true });
      setWebcamOn(true);
    }
  };

  const _toggleMic = async () => {
    // Prevent webinar participants from toggling microphone
    if (
      meetingSettings?.roomType === "Webinar" &&
      !["moderator", "co-host", "speaker"].includes(meetingRole)
    ) {
      return;
    }

    const audioTrack = audioTrackRef.current;

    if (micOn) {
      if (audioTrack) {
        audioTrack.stop();
        setAudioTrack(null);
        setCustomAudioStream(null);
        setMicOn(false);
        // Clean up noise processor when mic is turned off
        if (noiseProcessorRef.current) {
          try {
            if (noiseProcessorRef.current.stopProcessing) {
              await noiseProcessorRef.current.stopProcessing();
            }
          } catch (error) {
            // Ignore errors when stopping
            logger("log", "Error stopping noise processor:", error);
          }
          noiseProcessorRef.current = null;
        }
      }
    } else {
      if (false) {
        // Create a new noise processor instance each time to avoid "processing has already started" error
        if (noiseProcessorRef.current) {
          try {
            // Try to stop existing processing if possible
            if (noiseProcessorRef.current.stopProcessing) {
              await noiseProcessorRef.current.stopProcessing();
            }
          } catch (error) {
            // Ignore errors when stopping
            logger("log", "Error stopping noise processor:", error);
          }
        }
        noiseProcessorRef.current = new VideoSDKNoiseSuppressor();

        const stream = await createMicrophoneAudioTrack({});
        const processedStream =
          await noiseProcessorRef.current.getNoiseSuppressedAudioStream(stream);

        // Set the processed stream directly instead of calling changeMic
        setCustomAudioStream(processedStream);
        const audioTracks = processedStream?.getAudioTracks();
        const newAudioTrack = audioTracks?.length ? audioTracks[0] : null;
        clearInterval(audioAnalyserIntervalRef.current);
        setAudioTrack(newAudioTrack);
        setMicOn(true);
      } else {
        getDefaultMediaTracks({ mic: true, webcam: false });
        setMicOn(true);
      }
    }
  };

  const changeWebcam = async (deviceId) => {
    if (webcamOn) {
      const currentvideoTrack = videoTrackRef.current;
      if (currentvideoTrack) {
        currentvideoTrack.stop();
      }

      const stream = await getVideoTrack({
        webcamId: deviceId,
      });
      setCustomVideoStream(stream);
      const videoTracks = stream?.getVideoTracks();
      const videoTrack = videoTracks?.length ? videoTracks[0] : null;
      setVideoTrack(videoTrack);
    }
  };

  const changeMic = async (deviceId) => {
    if (micOn) {
      const currentAudioTrack = audioTrackRef.current;
      currentAudioTrack && currentAudioTrack.stop();
      const stream = await getAudioTrack({
        micId: deviceId,
      });
      setCustomAudioStream(stream);
      const audioTracks = stream?.getAudioTracks();
      const audioTrack = audioTracks?.length ? audioTracks[0] : null;
      clearInterval(audioAnalyserIntervalRef.current);
      setAudioTrack(audioTrack);
    }
  };

  const getDefaultMediaTracks = async ({ mic, webcam }) => {
    if (mic) {
      const stream = await getAudioTrack({
        micId: selectedMic.id,
      });
      setCustomAudioStream(stream);
      const audioTracks = stream?.getAudioTracks();
      const audioTrack = audioTracks?.length ? audioTracks[0] : null;
      setAudioTrack(audioTrack);
    }

    if (webcam) {
      const stream = await getVideoTrack({
        webcamId: selectedWebcam?.id,
      });
      setCustomVideoStream(stream);
      const videoTracks = stream?.getVideoTracks();
      const videoTrack = videoTracks?.length ? videoTracks[0] : null;
      setVideoTrack(videoTrack);
    }
  };

  async function startMuteListener() {
    const currentAudioTrack = audioTrackRef.current;
    if (currentAudioTrack) {
      if (currentAudioTrack.muted) {
        setDlgMuted(true);
      }
      currentAudioTrack.addEventListener("mute", (ev) => {
        setDlgMuted(true);
      });
    }
  }

  const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.vendor && navigator.vendor.indexOf("Apple") > -1);

  async function requestAudioVideoPermission(mediaType) {
    try {
      const permission = await requestPermission(mediaType);

      if (isFirefox) {
        const isVideoAllowed = permission.get("video");
        setIsCameraPermissionAllowed(isVideoAllowed);
        if (isVideoAllowed) {
          setWebcamOn(true);
          await getDefaultMediaTracks({ mic: false, webcam: true });
        }
      }

      if (isFirefox) {
        const isAudioAllowed = permission.get("audio");
        setIsMicrophonePermissionAllowed(isAudioAllowed);
        if (isAudioAllowed) {
          setMicOn(true);
          await getDefaultMediaTracks({ mic: true, webcam: false });
        }
      }

      if (mediaType === Constants.permission.AUDIO) {
        const isAudioAllowed = permission.get(Constants.permission.AUDIO);
        setIsMicrophonePermissionAllowed(isAudioAllowed);
        if (isAudioAllowed) {
          setMicOn(true);
          await getDefaultMediaTracks({ mic: true, webcam: false });
        }
      }

      if (mediaType === Constants.permission.VIDEO) {
        const isVideoAllowed = permission.get(Constants.permission.VIDEO);
        setIsCameraPermissionAllowed(isVideoAllowed);
        if (isVideoAllowed) {
          setWebcamOn(true);
          await getDefaultMediaTracks({ mic: false, webcam: true });
        }
      }
    } catch (ex) {
      logger("log", "Error in requestPermission ", ex);
    }
  }

  function onDeviceChanged() {
    setDidDeviceChange(true);
    getCameraDevices();
    getAudioDevices();
    getDefaultMediaTracks({ mic: micRef.current, webcam: webcamRef.current });
  }

  const checkPermissionStatus = async () => {
    try {
      const checkAudioVideoPermission = await checkPermissions();
      const cameraPermissionAllowed = checkAudioVideoPermission.get(
        Constants.permission.VIDEO
      );
      const microphonePermissionAllowed = checkAudioVideoPermission.get(
        Constants.permission.AUDIO
      );

      // Check if permissions are explicitly denied using Permissions API
      if (navigator.permissions && navigator.permissions.query) {
        try {
          let cameraDenied = false;
          let micDenied = false;

          try {
            const cameraPermission = await navigator.permissions.query({ name: 'camera' });
            cameraDenied = cameraPermission.state === 'denied';
          } catch (e) {
            // Camera permission query not supported, fallback to checking allowed status
            cameraDenied = !cameraPermissionAllowed && isCameraPermissionAllowed === false;
          }

          try {
            const micPermission = await navigator.permissions.query({ name: 'microphone' });
            micDenied = micPermission.state === 'denied';
          } catch (e) {
            // Microphone permission query not supported, fallback to checking allowed status
            micDenied = !microphonePermissionAllowed && isMicrophonePermissionAllowed === false;
          }

          setPermissionDenied({
            camera: cameraDenied,
            microphone: micDenied,
          });
        } catch (permError) {
          // Fallback: if permissions API fails, only show denied if explicitly false after request
          setPermissionDenied({
            camera: !cameraPermissionAllowed && isCameraPermissionAllowed === false,
            microphone: !microphonePermissionAllowed && isMicrophonePermissionAllowed === false,
          });
        }
      } else {
        // Fallback for browsers without Permissions API
        // Only show as denied if permission was explicitly set to false (meaning we tried and it failed)
        setPermissionDenied({
          camera: !cameraPermissionAllowed && isCameraPermissionAllowed === false,
          microphone: !microphonePermissionAllowed && isMicrophonePermissionAllowed === false,
        });
      }
    } catch (error) {
      logger("log", "Error checking permission status:", error);
    }
  };

  const checkMediaPermission = async () => {
    // Skip media initialization for webinar participants (non-moderators)
    if (
      meetingSettings?.roomType === "Webinar" &&
      !["moderator", "co-host", "speaker"].includes(meetingRole)
    ) {
      logger("log", "Webinar participant - skipping media initialization");
      setMicOn(false);
      setWebcamOn(false);
      return;
    }

    try {
      const checkAudioVideoPermission = await checkPermissions();
      const cameraPermissionAllowed = checkAudioVideoPermission.get(
        Constants.permission.VIDEO
      );
      const microphonePermissionAllowed = checkAudioVideoPermission.get(
        Constants.permission.AUDIO
      );

      setIsCameraPermissionAllowed(cameraPermissionAllowed);
      setIsMicrophonePermissionAllowed(microphonePermissionAllowed);

      // Check permission status for denied state
      await checkPermissionStatus();

      // For Safari, explicitly request permissions if not granted
      // Safari may return false/null/undefined when permissions haven't been requested yet
      if (isSafari) {
        // Request microphone permission if not granted
        if (!microphonePermissionAllowed) {
          await requestAudioVideoPermission(Constants.permission.AUDIO);
          // Re-check permission status after request
          await checkPermissionStatus();
        } else {
          setMicOn(true);
          getDefaultMediaTracks({ mic: true, webcam: false });
        }

        // Request camera permission if not granted
        if (!cameraPermissionAllowed) {
          await requestAudioVideoPermission(Constants.permission.VIDEO);
          // Re-check permission status after request
          await checkPermissionStatus();
        } else {
          setWebcamOn(true);
          getDefaultMediaTracks({ mic: false, webcam: true });
        }
      } else {
        // For other browsers, use existing logic
        if (microphonePermissionAllowed) {
          setMicOn(true);
          getDefaultMediaTracks({ mic: true, webcam: false });
        } else {
          await requestAudioVideoPermission(Constants.permission.AUDIO);
          // Re-check permission status after request
          await checkPermissionStatus();
        }
        if (cameraPermissionAllowed) {
          setWebcamOn(true);
          getDefaultMediaTracks({ mic: false, webcam: true });
        } else {
          await requestAudioVideoPermission(Constants.permission.VIDEO);
          // Re-check permission status after request
          await checkPermissionStatus();
        }
      }
    } catch (error) {
      // If checkPermissions fails, try requesting permissions directly (especially for Safari)
      if (isSafari) {
        await requestAudioVideoPermission(Constants.permission.AUDIO);
        await requestAudioVideoPermission(Constants.permission.VIDEO);
      } else {
        await requestAudioVideoPermission();
      }
      // Check permission status after error
      await checkPermissionStatus();
      logger("log", error);
    }
  };

  const getCameraDevices = async () => {
    try {
      if (permissonAvaialble.current?.isCameraPermissionAllowed) {
        let webcams = await getCameras();
        setSelectedWebcam({
          id: webcams[0]?.deviceId,
          label: webcams[0]?.label,
        });
        setDevices((devices) => {
          return { ...devices, webcams };
        });
      }
    } catch (err) {
      logger("log", "Error in getting camera devices", err);
    }
  };

  const getAudioDevices = async () => {
    try {
      if (permissonAvaialble.current?.isMicrophonePermissionAllowed) {
        let mics = await getMicrophones();
        let speakers = await getPlaybackDevices();
        const hasMic = mics.length > 0;
        if (hasMic) {
          startMuteListener();
        }

        setSelectedSpeaker({
          id: speakers[0]?.deviceId,
          label: speakers[0]?.label,
        });
        await setSelectedMic({
          id: mics[0]?.deviceId,
          label: mics[0]?.label,
        });
        setDevices((devices) => {
          return { ...devices, mics, speakers };
        });
      }
    } catch (err) {
      logger("log", "Error in getting audio devices", err);
    }
  };

  useEffect(() => {
    getAudioDevices();
  }, []);

  // Mic test functionality useEffects
  useEffect(() => {
    if (audioTrack) {
      analyseAudio(audioTrack);
    } else {
      stopAudioAnalyse();
    }
  }, [audioTrack]);

  useEffect(() => {
    if (didDeviceChange) {
      setDidDeviceChange(false);
      if (
        mediaRecorder.current != null &&
        mediaRecorder.current.state === "recording"
      ) {
        stopRecording();
      }
      setRecordingProgress(0);
      setRecordingStatus("inactive");
    }
  }, [didDeviceChange]);

  const handleLaunchRoom = async () => {
    // Validate name is required
    if (!userName || userName.trim() === "") {
      setNameError(true);
      toast.error("Please enter your name to join the meeting", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeButton: false,
      });
      return;
    }

    // Clear name error if name is valid
    if (nameError) {
      setNameError(false);
    }

    // Log the password
    const password = passwordDigits.join("");
    // logger("log", 'Password entered:', password);
    setParticipantName(userName);
    localStorage.setItem("participantName", userName);
    const token = await getToken();
    // const { meetingId, err } = await createMeeting({ token });
    // logger("log", "err", err);
    if (meetingId) {
      if (
        meetingSettings &&
        meetingSettings.requirePassword &&
        password !== meetingSettings.password
      ) {
        setPasswordError(true);
        return;
      }
      setToken(token);
      setMeetingId(meetingId);

      // For webinars, disable audio and video for non-moderators
      if (
        meetingSettings &&
        meetingSettings.roomType === "Webinar" &&
        !["moderator", "co-host", "speaker"].includes(meetingRole)
      ) {
        if (micOn) {
          _toggleMic();
        }
        if (webcamOn) {
          _toggleWebcam();
        }
      }

      // Mute participants if setting is enabled
      if (
        !["moderator", "co-host", "speaker"].includes(meetingRole) &&
        meetingSettings &&
        meetingSettings.muteParticipants &&
        micOn
      ) {
        _toggleMic();
      }
      if (localStorage.getItem("lowres")) {
        const stream = await createCameraVideoTrack({
          optimizationMode: "motion",
          encoderConfig: "h360p_w640p",
          facingMode: "environment",
          multiStream: false,
        });
        setCustomVideoStream(stream);
        changeWebcam(stream.id);
        localStorage.removeItem("lowres");
      }

      onClickStartMeeting();
    } else {
      // toast(`${err}`, {
      //     position: "bottom-left",
      //     autoClose: 4000,
      //     hideProgressBar: true,
      //     closeButton: false,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      // });
    }
  };

  const copyRoomName = () => {
    navigator.clipboard.writeText(roomName);
    toast("Room name copied to clipboard", {
      position: "bottom-left",
      autoClose: 2000,
      hideProgressBar: true,
      closeButton: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setCopiedRoomName(true);
    setTimeout(() => {
      setCopiedRoomName(false);
    }, 2000);
  };

  // Mic test functionality
  const mimeType = "audio/webm";

  const analyseAudio = (audioTrack) => {
    if (!micOn) return;
    const audioStream = new MediaStream([audioTrack]);
    const audioContext = new AudioContext();
    const audioSource = audioContext.createMediaStreamSource(audioStream);
    const analyser = audioContext.createAnalyser();

    analyser.fftSize = 512;
    analyser.minDecibels = -127;
    analyser.maxDecibels = 0;
    analyser.smoothingTimeConstant = 0.4;

    audioSource.connect(analyser);

    const volumes = new Uint8Array(analyser.frequencyBinCount);
    const volumeCallback = () => {
      analyser.getByteFrequencyData(volumes);
      const volumeSum = volumes.reduce((sum, vol) => sum + vol);
      const averageVolume = volumeSum / volumes.length;
      // make it smoother
      setVolume(averageVolume / 18.6666);
    };
    audioAnalyserIntervalRef.current = setInterval(volumeCallback, 500);
  };

  const stopAudioAnalyse = () => {
    clearInterval(audioAnalyserIntervalRef.current);
  };

  const handlePlaying = () => {
    setRecordingStatus("playing");
    const audioTags = document.getElementsByTagName("audio");

    for (let i = 0; i < audioTags.length; i++) {
      audioTags
        .item(i)
        .setSinkId(selectedSpeaker?.id)
        .then(() => {
          audioTags.item(i).play();
          audioTags.item(i).addEventListener("timeupdate", () => {
            const progress =
              (audioTags.item(i).currentTime / recordingDuration) * 100;
            setAudioProgress(progress);
          });
          audioTags.item(i).addEventListener("ended", () => {
            setAudioProgress(0);
          });
        });
    }
  };

  const startRecording = async () => {
    setRecordingStatus("recording");

    try {
      const media = new MediaRecorder(customAudioStream, { type: mimeType });
      mediaRecorder.current = media;
      mediaRecorder.current.start();
      let localAudioChunks = [];

      mediaRecorder.current.ondataavailable = (event) => {
        if (typeof event.data === "undefined") return;
        if (event.data.size === 0) return;
        localAudioChunks.push(event.data);
      };

      mediaRecorder.current.onstop = () => {
        const audioBlob = new Blob(localAudioChunks, { type: mimeType });
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudio(audioUrl);
        localAudioChunks = [];
        const elapsedTime = Date.now() - startTime;
        const durationInSeconds = elapsedTime / 1000;
        setRecordingDuration(durationInSeconds);
      };

      const startTime = Date.now();
      intervalRef.current = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        const progress = (elapsedTime / 7000) * 100;
        setRecordingProgress(progress);
      });

      setTimeout(() => {
        clearInterval(intervalRef.current);
        stopRecording();
      }, 7000);
    } catch (err) {
      logger("log", "Error in MediaRecorder:", err);
    }
  };

  const stopRecording = () => {
    if (mediaRecorder.current && mediaRecorder.current.state != "inactive") {
      setRecordingProgress(0);
      setRecordingStatus("stopped recording");
      clearInterval(intervalRef.current);
      mediaRecorder.current.stop();
    }
  };

  const testingSpeaker = () => {
    setTestSpeaker(!testSpeaker);
  };

  // Placeholder components for missing icons
  const MicIcon = ({ isOn }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      width="28"
      height="28"
      style={{ color: isOn ? "rgb(30, 217, 96)" : "red" }}
    >
      <path
        d="M202.57,125.6v38.26c0,29.32-23.86,53.18-53.18,53.18l.03.11c-28.77-.64-52-24.23-52-53.15v-38.26h-14.16v38.26c0,35.62,27.79,64.84,62.83,67.17v44.91h-29.45v14.16h71.11v-14.16h-27.5v-45.52l-.17-.24c32.07-5.14,56.65-32.97,56.65-66.47v-38.26h-14.16Z"
        fill="currentColor"
      ></path>
      <path
        d="M150.61,198.57c20.43,0,37.15-16.71,37.15-37.15V46.91c0-20.43-16.71-37.15-37.15-37.15s-37.15,16.71-37.15,37.15v114.52c0,20.43,16.71,37.15,37.15,37.15Z"
        fill="currentColor"
      ></path>
    </svg>
  );

  const CameraIcon = ({ isOn }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      width="28"
      height="28"
      style={{ color: isOn ? "rgb(30, 217, 96)" : "red" }}
    >
      <path
        d="M70.66,34.48v-.96c0-2.08-.55-4.04-1.51-5.73l-44.17,44.17c.48.06.97.1,1.47.1h32.57c6.43,0,11.63-5.21,11.63-11.63v-1.42l15.74,7.64V27.2l-15.74,7.27Z"
        fill="currentColor"
      ></path>
      <path
        d="M74.1,18.37l-1.51-1.51-2.23-2.23-7.8,7.8c-1.12-.36-2.3-.55-3.54-.55H26.45c-6.43,0-11.63,5.21-11.63,11.63v26.9c0,2.73.95,5.25,2.53,7.23l-7.91,7.91,3.74,3.74,1.57-1.57,6.77-6.77,45.7-45.7,6.88-6.88Z"
        fill="currentColor"
      ></path>
    </svg>
  );

  const ScreenShareIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 512 512"
      style={{ color: "red" }}
    >
      <path
        d="M0 0 C6.52984143 5.30549616 9.92921656 11.40483717 12.5625 19.3046875 C13.35381511 31.14397889 12.32590663 39.96176853 4.6484375 49.2265625 C-2.13629399 55.98588301 -10.33833999 59.2023819 -19.8125 59.6171875 C-29.76278878 59.32604308 -37.17251403 55.49804101 -44.16015625 48.60546875 C-50.459218 41.71828822 -52.80207104 34.02582132 -52.6484375 24.76171875 C-51.86413535 15.6260511 -48.03599328 7.28094242 -41.0703125 1.2578125 C-28.6795555 -7.85636134 -12.85904709 -8.94363211 0 0 Z "
        fill="currentColor"
        transform="translate(318.4375,186.6953125)"
      ></path>
    </svg>
  );

  const CameraOffIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      width="32"
      height="32"
      className="text-white"
    >
      <path
        d="M70.66,34.48v-.96c0-2.08-.55-4.04-1.51-5.73l-44.17,44.17c.48.06.97.1,1.47.1h32.57c6.43,0,11.63-5.21,11.63-11.63v-1.42l15.74,7.64V27.2l-15.74,7.27Z"
        fill="currentColor"
      ></path>
      <path
        d="M74.1,18.37l-1.51-1.51-2.23-2.23-7.8,7.8c-1.12-.36-2.3-.55-3.54-.55H26.45c-6.43,0-11.63,5.21-11.63,11.63v26.9c0,2.73.95,5.25,2.53,7.23l-7.91,7.91,3.74,3.74,1.57-1.57,6.77-6.77,45.7-45.7,6.88-6.88Z"
        fill="currentColor"
      ></path>
    </svg>
  );

  const CopyIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
    >
      <path
        d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.4"
      ></path>
    </svg>
  );

  const PersonIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="w-5 h-5"
    >
      <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm-7 7a7 7 0 0 1 14 0 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"></path>
    </svg>
  );

  const testSpeakers = () => {
    const selectedSpeakerDeviceId = selectedSpeaker.id;
    if (selectedSpeakerDeviceId) {
      const audio = new Audio(test_sound);
      try {
        audio.setSinkId(selectedSpeakerDeviceId).then(() => {
          audio.play();
          // setIsPlaying(true)
          // audio.addEventListener('timeupdate', () => {
          //     const progress = (audio.currentTime / audio.duration) * 100;
          //     setAudioProgress(progress);
          // });
          // audio.addEventListener('ended', () => {

          // });
        });
      } catch (error) {
        logger("log", error);
      }
      audio.play().catch((error) => {
        logger("error", "Failed to set sinkId:", error);
      });
    } else {
      logger("error", "Selected speaker deviceId not found.");
    }
  };

  useEffect(() => {
    if (selectedBackground) {
      handleStartVirtualBackground();
    } else {
      changeWebcam(selectedWebcam.id);
    }
  }, [selectedBackground]);

  // Fetch custom backgrounds when user is authenticated
  useEffect(() => {
    if (isAuthenticated) {
      fetchCustomBackgrounds();
    }
  }, [isAuthenticated]);

  // Fetch custom backgrounds
  const fetchCustomBackgrounds = async () => {
    try {
      const response =
        await virtualBackgroundServices.getUserVirtualBackgrounds();
      if (response.success && response.data) {
        setCustomBackgrounds(response.data);
      }
    } catch (error) {
      logger("error", "Error fetching custom backgrounds:", error);
    }
  };

  // Handle file upload
  const handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only image files (JPEG, PNG, GIF, WebP) are allowed");
      return;
    }

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.error("File size must be less than 10MB");
      return;
    }

    setUploadingBackground(true);
    try {
      const response = await virtualBackgroundServices.uploadVirtualBackground(
        file
      );
      if (response.success) {
        toast.success("Background uploaded successfully!");
        // Add to custom backgrounds list
        setCustomBackgrounds((prev) => [response.data, ...prev]);
        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.error(response.message || "Failed to upload background");
      }
    } catch (error) {
      logger("error", "Error uploading background:", error);
      toast.error(
        error.response?.data?.message || "Failed to upload background"
      );
    } finally {
      setUploadingBackground(false);
    }
  };

  // Handle delete custom background - show confirmation modal
  const handleDeleteBackground = (backgroundId, event) => {
    event.stopPropagation();
    setBackgroundToDelete(backgroundId);
    setShowDeleteConfirmModal(true);
  };

  // Confirm and execute delete
  const confirmDeleteBackground = async () => {
    if (!backgroundToDelete) return;

    try {
      const response = await virtualBackgroundServices.deleteVirtualBackground(
        backgroundToDelete
      );
      if (response.success) {
        toast.success("Background deleted successfully");
        // Remove from custom backgrounds list
        setCustomBackgrounds((prev) =>
          prev.filter((bg) => (bg._id || bg.id) !== backgroundToDelete)
        );
      } else {
        toast.error(response.message || "Failed to delete background");
      }
    } catch (error) {
      logger("error", "Error deleting background:", error);
      toast.error(
        error.response?.data?.message || "Failed to delete background"
      );
    } finally {
      setShowDeleteConfirmModal(false);
      setBackgroundToDelete(null);
    }
  };

  const handleStartVirtualBackground = async (
    imageUrl = null,
    enableBlur = null
  ) => {
    if (imageUrl === null && enableBlur === false) {
      setSelectedBackground(null);
      setBlurEnabled(false);
      setVirtualBackgroundOn(false);
      setShowVirtualBackground(false);
      changeWebcam(selectedWebcam.id);
      return;
    }

    if (!videoProcessor.ready) {
      await videoProcessor.init();
    }

    const shouldBlur = enableBlur !== null ? enableBlur : blurEnabled;

    const backgroundUrl =
      imageUrl !== null
        ? imageUrl
        : selectedBackground ||
        "https://cdn.videosdk.live/virtual-background/cloud.jpeg";

    // Update state
    if (imageUrl !== null) {
      setSelectedBackground(imageUrl);
      setVirtualBackgroundOn(true);
      setShowVirtualBackground(true);
    }
    if (enableBlur !== null) {
      setBlurEnabled(enableBlur);
      if (enableBlur) {
        setVirtualBackgroundOn(true);
        setShowVirtualBackground(true);
      }
    }

    // Configuration for starting processor
    const config = {
      type: shouldBlur ? "blur" : "image",
      imageUrl: shouldBlur ? undefined : backgroundUrl,
      // Here is a list of background images you can use for your project.
      // imageUrl: "https://cdn.videosdk.live/virtual-background/beach.jpeg",
      // imageUrl: "https://cdn.videosdk.live/virtual-background/san-fran.jpeg",
      // imageUrl: "https://cdn.videosdk.live/virtual-background/paper-wall.jpeg",
    };

    // Getting stream from webcam
    const stream = await createCameraVideoTrack({});
    const processedStream = await videoProcessor.start(stream, config);

    if (webcamOn) {
      const currentvideoTrack = videoTrackRef.current;
      if (currentvideoTrack) {
        currentvideoTrack.stop();
      }

      const stream = processedStream;
      setCustomVideoStream(stream);
      const videoTracks = stream?.getVideoTracks();
      const videoTrack = videoTracks?.length ? videoTracks[0] : null;
      setVideoTrack(videoTrack);
    }
  };

  const handlePasswordInput = (index, value) => {
    const newPasswordDigits = [...passwordDigits];
    newPasswordDigits[index] = value;
    setPasswordDigits(newPasswordDigits);

    // Clear error when user starts typing
    if (passwordError) {
      setPasswordError(false);
    }

    if (value && index < 3) {
      passwordInputRefs.current[index + 1]?.focus();
    }
  };

  const handlePasswordKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!passwordDigits[index] && index > 0) {
        const newPasswordDigits = [...passwordDigits];
        newPasswordDigits[index - 1] = "";
        setPasswordDigits(newPasswordDigits);
        passwordInputRefs.current[index - 1]?.focus();
      } else if (passwordDigits[index]) {
        const newPasswordDigits = [...passwordDigits];
        newPasswordDigits[index] = "";
        setPasswordDigits(newPasswordDigits);
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      passwordInputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < 3) {
      passwordInputRefs.current[index + 1]?.focus();
    }
  };

  const handlePasswordPaste = (e) => {
    const pastedText = e.clipboardData.getData("text");
    const newPasswordDigits = [...passwordDigits];
    for (let i = 0; i < pastedText.length; i++) {
      if (i < 4) {
        newPasswordDigits[i] = pastedText[i];
      }
    }
    setPasswordDigits(newPasswordDigits);

    const nextEmptyIndex = newPasswordDigits.findIndex((digit) => !digit);
    const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : 3;
    setTimeout(() => {
      passwordInputRefs.current[focusIndex]?.focus();
    }, 0);
  };

  return (
    <>
      <div
        className="sm:h-full sm:overflow-y-auto lg:h-screen lg:overflow-y-hidden flex flex-col text-slate-50 overflow-hidden font-sans"
        style={{
          background:
            "linear-gradient(to top, #38275B 0%, #251A3C 33.33333333333333%, #140E20 66.66666666666666%, #000000 100%)",
        }}
      >
        {/* Header with R logo */}
        <div className="flex-1 flex flex-col relative m-0 p-0">
          <div className="sticky top-0 z-20 px-4 sm:px-6 py-2 bg-black text-white border-b border-[#39364A] flex justify-between items-center">
            <div className="flex items-center">
              <img
                alt="R-Link"
                className="h-8 sm:h-10 w-auto mr-3"
                src="/r-link-fav.svg"
              />
            </div>
          </div>

          <div className="flex-1 flex items-start justify-start md:items-center md:justify-center p-0 m-0 min-h-0 overflow-hidden overflow-y-auto md:overflow-hidden">
            <div className="w-full min-h-screen bg-[linear-gradient(to_top,_#38275B_0%,_#251A3C_33.33333333333333%,_#140E20_66.66666666666666%,_#000000_100%)]">
              <div className="mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 items-start px-4 sm:px-6 py-4 sm:py-6 md:py-10 md:mt-[1%]">
                <div className="flex flex-col justify-center items-center w-full">
                  <h3
                    className="text-[#FFFFFF] text-base sm:text-lg tracking-widest mb-2 sm:mb-3 px-2"
                    style={{ letterSpacing: "0.3em" }}
                  >
                    PRE-LAUNCH CHECK
                  </h3>
                  <p className="text-[#FFFFFF] text-center text-xs mb-4 sm:mb-6 px-2">
                    Configure your audio and video before entering the room.
                  </p>

                  {/* Permission Denied Banner */}
                  {(permissionDenied.camera || permissionDenied.microphone) && (
                    <div className="w-full max-w-[500px] mb-3 sm:mb-4 bg-red-900/30 border border-red-500/50 rounded-lg p-3 sm:p-4">
                      <div className="flex items-start gap-2 sm:gap-3">
                        <svg
                          className="w-5 h-5 sm:w-6 sm:h-6 text-red-400 flex-shrink-0 mt-0.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                          />
                        </svg>
                        <div className="flex-1">
                          <h4 className="text-red-300 font-semibold text-sm sm:text-base mb-1">
                            Permission Access Denied
                          </h4>
                          <p className="text-red-200 text-xs sm:text-sm">
                            {permissionDenied.camera && permissionDenied.microphone
                              ? "Camera and microphone access have been denied. Please enable them in your browser settings to use video and audio features."
                              : permissionDenied.camera
                                ? "Camera access has been denied. Please enable it in your browser settings to use video features."
                                : "Microphone access has been denied. Please enable it in your browser settings to use audio features."}
                          </p>
                          <button
                            onClick={async () => {
                              await checkMediaPermission();
                            }}
                            className="mt-2 text-xs sm:text-sm text-red-300 hover:text-red-200 underline"
                          >
                            Try again
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="rounded-2xl sm:rounded-4xl overflow-hidden bg-black aspect-video mb-3 sm:mb-4 border border-white/10 relative w-full max-w-[500px]">
                    <video
                      autoPlay
                      playsInline
                      muted
                      ref={videoPlayerRef}
                      controls={false}
                      className={`w-full h-full object-cover rounded-2xl transition-opacity duration-300 ${webcamOn ? "opacity-100" : "opacity-0"
                        }`}
                    />
                    {!webcamOn && (
                      <div className="flex items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <div className="flex flex-col items-center gap-3">
                          {/* <div className="rounded-full h-8 w-8 border-b-2 border-white"></div> */}
                          <p className="text-white text-sm">
                            {permissionDenied.camera
                              ? "Camera permission denied"
                              : "No camera"}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center justify-center gap-4 sm:gap-6 text-slate-100 mb-8 sm:mb-12 mt-3 sm:mt-4">
                    <div className="relative inline-block">
                      <button
                        onClick={_toggleMic}
                        disabled={
                          meetingSettings?.roomType === "Webinar" &&
                          !["moderator", "co-host", "speaker"].includes(
                            meetingRole
                          ) ||
                          permissionDenied.microphone
                        }
                        type="button"
                        aria-label="Toggle microphone"
                        className={`touch-manipulation ${meetingSettings?.roomType === "Webinar" &&
                          !["moderator", "co-host", "speaker"].includes(
                            meetingRole
                          ) || permissionDenied.microphone
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                          }`}
                        title={permissionDenied.microphone ? "Microphone permission denied" : ""}
                      >
                        {micOn && (
                          <img
                            src={"/icons/micOnGreen.svg"}
                            alt="Mic"
                            draggable={false}
                            className="w-7 h-7 sm:w-auto sm:h-auto"
                          />
                        )}
                        {!micOn && (
                          <img
                            src={"/icons/micOff.svg"}
                            alt="Mic"
                            draggable={false}
                            className={`w-7 h-7 sm:w-auto sm:h-auto ${permissionDenied.microphone ? "opacity-50" : ""
                              }`}
                          />
                        )}
                        {permissionDenied.microphone && (
                          <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-black"></div>
                        )}
                      </button>
                    </div>
                    <span className="h-6 w-px bg-white/20"></span>
                    <div className="relative inline-block">
                      <button
                        onClick={_toggleWebcam}
                        disabled={
                          meetingSettings?.roomType === "Webinar" &&
                          !["moderator", "co-host", "speaker"].includes(
                            meetingRole
                          ) ||
                          permissionDenied.camera
                        }
                        type="button"
                        aria-label="Toggle camera"
                        className={`touch-manipulation ${meetingSettings?.roomType === "Webinar" &&
                          !["moderator", "co-host", "speaker"].includes(
                            meetingRole
                          ) || permissionDenied.camera
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                          }`}
                        title={permissionDenied.camera ? "Camera permission denied" : ""}
                      >
                        {webcamOn && (
                          <img
                            src={"/icons/videoGreen.svg"}
                            alt="Webcam"
                            draggable={false}
                            className="w-7 h-7 sm:w-auto sm:h-auto"
                          />
                        )}
                        {!webcamOn && (
                          <img
                            src={"/icons/videoOff.svg"}
                            alt="Webcam"
                            draggable={false}
                            className={`w-7 h-7 sm:w-auto sm:h-auto ${permissionDenied.camera ? "opacity-50" : ""
                              }`}
                          />
                        )}
                        {permissionDenied.camera && (
                          <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-black"></div>
                        )}
                      </button>
                    </div>
                    <span className="h-6 w-px bg-white/20"></span>
                    <div className="relative inline-block">
                      {!showVirtualBackground && (
                        <button
                          onClick={() => {
                            setShowVirtualBackground(true);
                            setVirtualBackgroundOn(true);
                            handleStartVirtualBackground();
                            setShowVirtualBackgroundModal(true);
                          }}
                          disabled={
                            meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                          }
                          type="button"
                          className={`text-white touch-manipulation ${meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                            }`}
                        >
                          <img
                            src={"/icons/blurbg.svg"}
                            alt="Blur Background"
                            draggable={false}
                            className="w-7 h-7 sm:w-auto sm:h-auto"
                          />
                        </button>
                      )}
                      {showVirtualBackground && (
                        <button
                          onClick={() => {
                            setShowVirtualBackground(false);
                            setVirtualBackgroundOn(false);
                            setSelectedBackground(null);
                            setBlurEnabled(false);
                            changeWebcam(selectedWebcam.id);
                          }}
                          disabled={
                            meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                          }
                          type="button"
                          className={`text-white touch-manipulation ${meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                            }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 512 512"
                            className="w-7 h-7 sm:w-7 sm:h-7"
                            style={{ color: "#00C853" }}
                          >
                            <path
                              d="M0 0 C6.52984143 5.30549616 9.92921656 11.40483717 12.5625 19.3046875 C13.35381511 31.14397889 12.32590663 39.96176853 4.6484375 49.2265625 C-2.13629399 55.98588301 -10.33833999 59.2023819 -19.8125 59.6171875 C-29.76278878 59.32604308 -37.17251403 55.49804101 -44.16015625 48.60546875 C-50.459218 41.71828822 -52.80207104 34.02582132 -52.6484375 24.76171875 C-51.86413535 15.6260511 -48.03599328 7.28094242 -41.0703125 1.2578125 C-28.6795555 -7.85636134 -12.85904709 -8.94363211 0 0 Z "
                              fill="currentColor"
                              transform="translate(318.4375,186.6953125)"
                            ></path>
                            <path
                              d="M0 0 C6.72127605 5.94957398 10.66712614 13.13199191 11.35546875 22.05859375 C11.72299581 32.38276294 10.03046506 39.62296127 3.484375 47.6796875 C-2.19619019 53.69002332 -9.52596207 57.49374376 -17.80859375 58.0703125 C-28.32810172 58.22112982 -35.60297231 56.75612522 -43.8125 49.953125 C-50.57182051 43.16839351 -53.7883194 34.96634751 -54.203125 25.4921875 C-53.91198058 15.54189872 -50.08397851 8.13217347 -43.19140625 1.14453125 C-30.76264957 -10.2228934 -13.35241027 -9.51714349 0 0 Z "
                              fill="currentColor"
                              transform="translate(319.890625,273.1328125)"
                            ></path>
                            <path
                              d="M0 0 C8.75644589 4.59139485 14.34147637 10.96080271 17.89453125 20.1953125 C20.34646906 28.68409031 19.54894237 37.03510332 16.0859375 45.09375 C10.85293988 54.02156108 3.61680107 59.91376318 -6.2890625 62.78125 C-16.8478422 64.03824758 -26.03503154 62.21164973 -34.8046875 55.9609375 C-41.52596355 50.01136352 -45.47181364 42.82894559 -46.16015625 33.90234375 C-46.52768331 23.57817456 -44.83515256 16.33797623 -38.2890625 8.28125 C-28.64371772 -1.9431774 -13.12921715 -5.27120986 0 0 Z "
                              fill="currentColor"
                              transform="translate(226.9140625,182.90625)"
                            ></path>
                            <path
                              d="M0 0 C7.25707503 5.93760684 12.60879954 12.66391614 13.75 22.25 C14.53466881 31.83827012 12.21700551 40.2841639 6.6171875 48.140625 C0.75581784 54.76225599 -6.38250593 58.75778678 -15.18359375 59.49609375 C-25.22695006 59.88647156 -33.24861994 58.04567946 -41.125 51.625 C-46.65560193 46.3421849 -50.93556976 38.95436018 -51.453125 31.2109375 C-51.59570846 20.30330276 -50.39570399 12.84750566 -43.3359375 4.328125 C-31.75595781 -7.20848398 -13.51742552 -9.62955646 0 0 Z "
                              fill="currentColor"
                              transform="translate(232.25,271.75)"
                            ></path>
                            <path
                              d="M0 0 C4.51595159 3.79750475 9.28342706 8.90913003 10 15 C10.4891914 22.33787096 9.51075768 28.01423411 4.6875 33.75 C-1.50923987 38.93796827 -5.73187929 41.35086236 -13.84765625 41.21484375 C-20.32579351 40.56820573 -24.82139544 37.991111 -29 33 C-33.41867079 26.98569809 -34.74662443 22.47981929 -34 15 C-32.33419903 7.87771713 -28.8082004 4.06316764 -22.9375 -0.25 C-15.64069078 -4.59703528 -7.36855671 -3.96158963 0 0 Z "
                              fill="currentColor"
                              transform="translate(396,365)"
                            ></path>
                            <path
                              d="M0 0 C4.51595159 3.79750475 9.28342706 8.90913003 10 15 C10.4891914 22.33787096 9.51075768 28.01423411 4.6875 33.75 C-1.50923987 38.93796827 -5.73187929 41.35086236 -13.84765625 41.21484375 C-20.32579351 40.56820573 -24.82139544 37.991111 -29 33 C-33.41867079 26.98569809 -34.74662443 22.47981929 -34 15 C-32.33419903 7.87771713 -28.8082004 4.06316764 -22.9375 -0.25 C-15.64069078 -4.59703528 -7.36855671 -3.96158963 0 0 Z "
                              fill="currentColor"
                              transform="translate(140,365)"
                            ></path>
                            <path
                              d="M0 0 C4.51595159 3.79750475 9.28342706 8.90913003 10 15 C10.4891914 22.33787096 9.51075768 28.01423411 4.6875 33.75 C-1.50923987 38.93796827 -5.73187929 41.35086236 -13.84765625 41.21484375 C-20.32579351 40.56820573 -24.82139544 37.991111 -29 33 C-33.41867079 26.98569809 -34.74662443 22.47981929 -34 15 C-32.33419903 7.87771713 -28.8082004 4.06316764 -22.9375 -0.25 C-15.64069078 -4.59703528 -7.36855671 -3.96158963 0 0 Z "
                              fill="currentColor"
                              transform="translate(396,109)"
                            ></path>
                            <path
                              d="M0 0 C4.51595159 3.79750475 9.28342706 8.90913003 10 15 C10.4891914 22.33787096 9.51075768 28.01423411 4.6875 33.75 C-1.50923987 38.93796827 -5.73187929 41.35086236 -13.84765625 41.21484375 C-20.32579351 40.56820573 -24.82139544 37.991111 -29 33 C-33.41867079 26.98569809 -34.74662443 22.47981929 -34 15 C-32.33419903 7.87771713 -28.8082004 4.06316764 -22.9375 -0.25 C-15.64069078 -4.59703528 -7.36855671 -3.96158963 0 0 Z "
                              fill="currentColor"
                              transform="translate(140,109)"
                            ></path>
                            <path
                              d="M0 0 C4.58145041 2.90469037 8.12684957 7.29323353 10.11328125 12.33984375 C10.97694355 19.72188361 11.24061599 26.62392031 6.6015625 32.7265625 C1.51563322 38.23965644 -3.03914286 40.95508616 -10.63671875 41.71484375 C-16.54717366 41.52235767 -22.29563697 39.58971311 -26.78515625 35.69140625 C-32.14106031 29.70846951 -33.35533552 24.29009703 -33.19921875 16.34765625 C-32.57840423 10.37231648 -30.27913394 6.76390474 -26.13671875 2.52734375 C-17.61977045 -3.20521761 -9.39712202 -4.56060671 0 0 Z "
                              fill="currentColor"
                              transform="translate(309.88671875,364.66015625)"
                            ></path>
                            <path
                              d="M0 0 C4.66634793 4.05184944 7.59854379 8.61563081 8.3359375 14.83203125 C8.4227458 21.45550454 8.05029573 26.59121999 4 32 C-1.24900959 37.36830526 -6.59619901 39.62179989 -13.9375 40.4375 C-19.56237669 40.17227988 -24.67947597 38.13250716 -28.83203125 34.31640625 C-34.51079798 27.89152418 -35.51296418 23.09480035 -35.37890625 14.48828125 C-34.68878205 8.13486978 -31.66047551 4.33475594 -27.0625 0.125 C-18.26486968 -5.97947818 -9.02106338 -5.15920347 0 0 Z "
                              fill="currentColor"
                              transform="translate(227,366)"
                            ></path>
                            <path
                              d="M0 0 C5.65842186 3.35748683 9.01834623 8.14105438 11.0546875 14.30859375 C12.61328751 20.65089687 11.70385218 25.48921562 8.90234375 31.26171875 C5.99765338 35.84316916 1.60911022 39.38856832 -3.4375 41.375 C-10.81953986 42.2386623 -17.72157656 42.50233474 -23.82421875 37.86328125 C-29.33731269 32.77735197 -32.05274241 28.22257589 -32.8125 20.625 C-32.62001392 14.71454509 -30.68736936 8.96608178 -26.7890625 4.4765625 C-19.38125262 -2.15488303 -9.29654974 -4.24177174 0 0 Z "
                              fill="currentColor"
                              transform="translate(394.4375,278.625)"
                            ></path>
                            <path
                              d="M0 0 C5.65842186 3.35748683 9.01834623 8.14105438 11.0546875 14.30859375 C12.61328751 20.65089687 11.70385218 25.48921562 8.90234375 31.26171875 C5.99765338 35.84316916 1.60911022 39.38856832 -3.4375 41.375 C-10.81953986 42.2386623 -17.72157656 42.50233474 -23.82421875 37.86328125 C-29.33731269 32.77735197 -32.05274241 28.22257589 -32.8125 20.625 C-32.62001392 14.71454509 -30.68736936 8.96608178 -26.7890625 4.4765625 C-19.38125262 -2.15488303 -9.29654974 -4.24177174 0 0 Z "
                              fill="currentColor"
                              transform="translate(138.4375,278.625)"
                            ></path>
                            <path
                              d="M0 0 C5.30020616 3.15174783 9.22263819 7.33459586 11.79296875 12.96484375 C13.52331869 20.83007076 12.47917854 27.09794769 8.48046875 34.08984375 C4.42861931 38.75619168 -0.13516206 41.68838754 -6.3515625 42.42578125 C-12.97503579 42.51258955 -18.11075124 42.14013948 -23.51953125 38.08984375 C-28.88783651 32.84083416 -31.14133114 27.49364474 -31.95703125 20.15234375 C-31.69181113 14.52746706 -29.65203841 9.41036778 -25.8359375 5.2578125 C-18.45660835 -1.26456229 -9.64671512 -3.48478236 0 0 Z "
                              fill="currentColor"
                              transform="translate(393.51953125,192.91015625)"
                            ></path>
                            <path
                              d="M0 0 C5.30020616 3.15174783 9.22263819 7.33459586 11.79296875 12.96484375 C13.52331869 20.83007076 12.47917854 27.09794769 8.48046875 34.08984375 C4.42861931 38.75619168 -0.13516206 41.68838754 -6.3515625 42.42578125 C-12.97503579 42.51258955 -18.11075124 42.14013948 -23.51953125 38.08984375 C-28.88783651 32.84083416 -31.14133114 27.49364474 -31.95703125 20.15234375 C-31.69181113 14.52746706 -29.65203841 9.41036778 -25.8359375 5.2578125 C-18.45660835 -1.26456229 -9.64671512 -3.48478236 0 0 Z "
                              fill="currentColor"
                              transform="translate(137.51953125,192.91015625)"
                            ></path>
                            <path
                              d="M0 0 C4.58145041 2.90469037 8.12684957 7.29323353 10.11328125 12.33984375 C10.97694355 19.72188361 11.24061599 26.62392031 6.6015625 32.7265625 C1.51563322 38.23965644 -3.03914286 40.95508616 -10.63671875 41.71484375 C-16.54717366 41.52235767 -22.29563697 39.58971311 -26.78515625 35.69140625 C-32.14106031 29.70846951 -33.35533552 24.29009703 -33.19921875 16.34765625 C-32.57840423 10.37231648 -30.27913394 6.76390474 -26.13671875 2.52734375 C-17.61977045 -3.20521761 -9.39712202 -4.56060671 0 0 Z "
                              fill="currentColor"
                              transform="translate(309.88671875,108.66015625)"
                            ></path>
                            <path
                              d="M0 0 C4.66634793 4.05184944 7.59854379 8.61563081 8.3359375 14.83203125 C8.4227458 21.45550454 8.05029573 26.59121999 4 32 C-1.24900959 37.36830526 -6.59619901 39.62179989 -13.9375 40.4375 C-19.56237669 40.17227988 -24.67947597 38.13250716 -28.83203125 34.31640625 C-34.51079798 27.89152418 -35.51296418 23.09480035 -35.37890625 14.48828125 C-34.68878205 8.13486978 -31.66047551 4.33475594 -27.0625 0.125 C-18.26486968 -5.97947818 -9.02106338 -5.15920347 0 0 Z "
                              fill="currentColor"
                              transform="translate(227,110)"
                            ></path>
                            <path
                              d="M0 0 C3.42215793 1.92885265 5.46291808 3.33142526 6.6953125 7.16015625 C7.28313201 10.90594227 7.27215819 13.34109071 5.8125 16.875 C2.60247767 20.63847445 1.2135049 21.86299138 -3.875 22.4375 C-8.14255061 22.28594213 -10.70519103 20.73228061 -14 18 C-15.84995114 14.30009772 -15.46986842 10.03832859 -15 6 C-11.479187 0.0510401 -6.67571461 -1.07063348 0 0 Z "
                              fill="currentColor"
                              transform="translate(303,437)"
                            ></path>
                            <path
                              d="M0 0 C3.58552881 1.63687185 4.79315055 2.68972583 7 6 C7.54602034 9.39107371 7.54627924 12.60874176 7 16 C4.80977082 18.82424288 3.16982793 20.41508603 0 22 C-4.93378393 22.49337839 -7.06919235 22.52463704 -11.4375 20.0625 C-14.73518395 16.12136552 -15.40632045 13.07900568 -15 8 C-12.10131796 0.98213822 -7.40154764 -1.10361048 0 0 Z "
                              fill="currentColor"
                              transform="translate(217,437)"
                            ></path>
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-3 w-full max-w-full sm:max-w-[420px]">
                    <div className="w-full">
                      <div className="relative w-full max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px] mb-3 sm:mb-4">
                        <button
                          onClick={() => setShowVideoOption(!showVideoOption)}
                          disabled={
                            meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                          }
                          type="button"
                          className={`w-full flex items-center gap-3 sm:gap-4 bg-white border border-slate-200 rounded-lg px-3 sm:px-3 py-2.5 sm:py-2.5 shadow-sm hover:border-slate-300 transition-colors touch-manipulation min-h-[44px] ${meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                            }`}
                        >
                          <div className="text-green-600">
                            <svg
                              width="31"
                              height="24"
                              viewBox="0 0 31 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M23.2772 7.98338L23.7203 7.76183V3.77447C23.7203 2.16477 22.4059 0.865234 20.811 0.865234H3.14854C1.53884 0.865234 0.239258 2.17954 0.239258 3.77447V20.226C0.239258 21.8357 1.5536 23.1352 3.14854 23.1352H20.811C22.4207 23.1352 23.7203 21.8209 23.7203 20.226V16.2386L23.2772 16.0171V7.99807V7.98338ZM12.7624 13.9348L8.99664 16.1057V7.40741L12.7624 9.57825L16.5283 11.7492L12.7624 13.92V13.9348Z"
                                fill="#1CD760"
                              />
                              <path
                                d="M23.7207 7.76203V16.2388L30.957 20.0046V12.0004V3.98145L23.7207 7.76203Z"
                                fill="#1CD760"
                              />
                              <path
                                d="M23.2773 7.98327V16.0022L23.7204 16.2385V7.76172L23.2773 7.98327Z"
                                fill="#1CD760"
                              />
                            </svg>
                          </div>
                          <span className="flex-1 text-left text-slate-900 text-sm">
                            {selectedWebcam?.label
                              ? selectedWebcam?.label
                              : "Select device"}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="-6.5 0 32 32"
                            width="16"
                            height="16"
                            className={`text-slate-500 transition-transform ${showVideoOption ? "rotate-180" : ""
                              }`}
                          >
                            <path
                              d="M18.813 11.406l-7.906 9.906c-0.75 0.906-1.906 0.906-2.625 0l-7.906-9.906c-0.75-0.938-0.375-1.656 0.781-1.656h16.875c1.188 0 1.531 0.719 0.781 1.656z"
                              fill="currentColor"
                            ></path>
                          </svg>
                        </button>

                        {showVideoOption && webcams && webcams.length > 0 && (
                          <div className="absolute bottom-full left-0 right-0 mb-1 bg-white border border-slate-200 rounded-lg shadow-lg z-10 max-h-48 overflow-y-auto">
                            {webcams.map((option, index) => (
                              <button
                                key={option.deviceId || index}
                                type="button"
                                onClick={() => {
                                  setSelectedWebcam((s) => ({
                                    ...s,
                                    id: option?.deviceId,
                                    label: option?.label,
                                  }));
                                  changeWebcam(option?.deviceId);
                                  setShowVideoOption(false);
                                }}
                                className={`w-full flex items-center gap-3 px-3 py-2.5 sm:py-2.5 text-left hover:bg-slate-50 transition-colors touch-manipulation min-h-[44px] ${selectedWebcam?.label === option?.label
                                  ? " text-green-700"
                                  : "text-slate-900"
                                  }`}
                              >
                                <div className="w-5 h-5 flex items-center justify-center">
                                  {selectedWebcam?.label === option?.label && (
                                    <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                                  )}
                                </div>
                                <span className="flex-1 text-sm">
                                  {option.label || option.deviceId}
                                </span>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full">
                      <div className="relative w-full max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px] mb-3 sm:mb-4">
                        <button
                          onClick={() => {
                            setShowAudioOption(!showAudioOption);
                            if (!showAudioOption) {
                              setShowMicTest(false);
                            }
                          }}
                          disabled={
                            meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                          }
                          type="button"
                          className={`w-full flex items-center gap-3 sm:gap-4 bg-white border border-slate-200 rounded-lg px-3 sm:px-3 py-2.5 sm:py-2.5 shadow-sm hover:border-slate-300 transition-colors touch-manipulation min-h-[44px] ${meetingSettings?.roomType === "Webinar" &&
                            !["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                            }`}
                        >
                          <div className="text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 300 300"
                              width="20"
                              height="20"
                              className=""
                              style={{ color: "rgb(30, 217, 96)" }}
                            >
                              <path
                                d="M202.57,125.6v38.26c0,29.32-23.86,53.18-53.18,53.18l.03.11c-28.77-.64-52-24.23-52-53.15v-38.26h-14.16v38.26c0,35.62,27.79,64.84,62.83,67.17v44.91h-29.45v14.16h71.11v-14.16h-27.5v-45.52l-.17-.24c32.07-5.14,56.65-32.97,56.65-66.47v-38.26h-14.16Z"
                                fill="currentColor"
                              ></path>
                              <path
                                d="M150.61,198.57c20.43,0,37.15-16.71,37.15-37.15V46.91c0-20.43-16.71-37.15-37.15-37.15s-37.15,16.71-37.15,37.15v114.52c0,20.43,16.71,37.15,37.15,37.15Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </div>
                          <span className="flex-1 text-left text-slate-900 text-sm">
                            {selectedMic?.label
                              ? selectedMic?.label
                              : "Select device"}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="-6.5 0 32 32"
                            width="16"
                            height="16"
                            className={`text-slate-500 transition-transform ${showAudioOption ? "rotate-180" : ""
                              }`}
                          >
                            <path
                              d="M18.813 11.406l-7.906 9.906c-0.75 0.906-1.906 0.906-2.625 0l-7.906-9.906c-0.75-0.938-0.375-1.656 0.781-1.656h16.875c1.188 0 1.531 0.719 0.781 1.656z"
                              fill="currentColor"
                            ></path>
                          </svg>
                        </button>
                        {showAudioOption && mics && mics.length > 0 && (
                          <div className="absolute bottom-full left-0 right-0 mb-1 bg-white border border-slate-200 rounded-lg shadow-lg z-10 max-h-48 overflow-y-auto">
                            {mics.map((option, index) => (
                              <button
                                key={option.deviceId || index}
                                type="button"
                                onClick={() => {
                                  setSelectedMic((s) => ({
                                    ...s,
                                    label: option?.label,
                                    id: option?.deviceId,
                                  }));
                                  changeMic(option?.deviceId);
                                  setShowAudioOption(false);
                                  // if (mediaRecorder.current != null && mediaRecorder.current.state == "recording") { stopRecording() }
                                  // setRecordingProgress(0)
                                  // setRecordingStatus("inactive")
                                }}
                                className={`w-full flex items-center gap-3 px-3 py-2.5 sm:py-2.5 text-left hover:bg-slate-50 transition-colors touch-manipulation min-h-[44px] ${option.label === selectedMic.label
                                  ? " text-green-700"
                                  : "text-slate-900"
                                  }`}
                              >
                                <div className="w-5 h-5 flex items-center justify-center">
                                  {option.label === selectedMic.label && (
                                    <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                                  )}
                                </div>
                                <span className="flex-1 text-sm">
                                  {option.label || option.deviceId}
                                </span>
                              </button>
                            ))}
                          </div>
                        )}

                        {/* Audio Level Indicator */}
                        <div className="hidden sm:flex absolute -right-24 top-1/2 -translate-y-1/2 items-end gap-1 h-7 pr-1 pointer-events-none">
                          {[...Array(6)].map((_, i) => (
                            <div
                              key={i}
                              className={`w-2 h-full transition-all duration-250 ${micOn && i < volume
                                ? "bg-[#800080]"
                                : "bg-slate-200"
                                }`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    {!isMobile && (
                      <div className="w-full">
                        <div className="relative w-full max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px] mb-3 sm:mb-4">
                          <button
                            onClick={() => {
                              setShowSpeakerOption(!showSpeakerOption);
                            }}
                            type="button"
                            className="w-full flex items-center gap-3 sm:gap-4 bg-white border border-slate-200 rounded-lg px-3 sm:px-3 py-2.5 sm:py-2.5 shadow-sm hover:border-slate-300 transition-colors touch-manipulation min-h-[44px]"
                          >
                            <div className="text-green-600">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 -1.5 31 31"
                                width="20"
                                height="20"
                                className=""
                                style={{ color: "rgb(30, 217, 96)" }}
                              >
                                <g fill="currentColor" fillRule="evenodd">
                                  <path
                                    d="M277,571.015 L277,573.068 C282.872,574.199 287,578.988 287,585 C287,590.978 283,595.609 277,596.932 L277,598.986 C283.776,597.994 289,592.143 289,585 C289,577.857 283.776,572.006 277,571.015 L277,571.015 Z M272,573 L265,577.667 L265,592.333 L272,597 C273.104,597 274,596.104 274,595 L274,575 C274,573.896 273.104,573 272,573 L272,573 Z M283,585 C283,581.477 280.388,578.59 277,578.101 L277,580.101 C279.282,580.564 281,582.581 281,585 C281,587.419 279.282,589.436 277,589.899 L277,591.899 C280.388,591.41 283,588.523 283,585 L283,585 Z M258,581 L258,589 C258,590.104 258.896,591 260,591 L263,591 L263,579 L260,579 C258.896,579 258,579.896 258,581 L258,581 Z"
                                    transform="translate(-258 -571)"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                            <span className="flex-1 text-left text-slate-900 text-sm">
                              {selectedSpeaker?.label
                                ? selectedSpeaker?.label
                                : "Select device"}
                            </span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="-6.5 0 32 32"
                              width="16"
                              height="16"
                              className={`text-slate-500 transition-transform ${showSpeakerOption ? "rotate-180" : ""
                                }`}
                            >
                              <path
                                d="M18.813 11.406l-7.906 9.906c-0.75 0.906-1.906 0.906-2.625 0l-7.906-9.906c-0.75-0.938-0.375-1.656 0.781-1.656h16.875c1.188 0 1.531 0.719 0.781 1.656z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </button>

                          {showSpeakerOption &&
                            speakers &&
                            speakers.length > 0 && (
                              <div className="absolute bottom-full left-0 right-0 mb-1 bg-white border border-slate-200 rounded-lg shadow-lg z-10 max-h-48 overflow-y-auto">
                                {speakers.map((option, index) => (
                                  <button
                                    key={option.deviceId || index}
                                    type="button"
                                    onClick={() => {
                                      setSelectedSpeaker((s) => ({
                                        ...s,
                                        id: option?.deviceId,
                                        label: option?.label,
                                      }));
                                      setShowSpeakerOption(false);
                                    }}
                                    className={`w-full flex items-center gap-3 px-3 py-2.5 sm:py-2.5 text-left hover:bg-slate-50 transition-colors touch-manipulation min-h-[44px] ${selectedWebcam?.label === option?.label
                                      ? " text-green-700"
                                      : "text-slate-900"
                                      }`}
                                  >
                                    <div className="w-5 h-5 flex items-center justify-center">
                                      {selectedWebcam?.label ===
                                        option?.label && (
                                          <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                                        )}
                                    </div>
                                    <span className="flex-1 text-sm">
                                      {option.label || option.deviceId}
                                    </span>
                                  </button>
                                ))}
                              </div>
                            )}

                          <div className="hidden sm:flex absolute -right-12 top-1/2 -translate-y-1/2 items-center justify-center h-4 pr-1">
                            <div className="relative inline-block">
                              <button
                                onClick={testSpeakers}
                                type="button"
                                aria-label="Play test sound"
                                className="p-1 rounded-md bg-slate-100 text-purple-700"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                  className="w-4 h-4 "
                                >
                                  <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l2.25-2.25a.75.75 0 0 0 0-1.06l-2.25-2.25Zm-11.56 0a.75.75 0 0 0-1.06-1.06L6.56 12l1.72-1.72a.75.75 0 0 0-1.06-1.06L4.03 12.53a.75.75 0 0 0 0 1.06l2.25 2.25Z"></path>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <audio
                      src="/audio/cartoon-door-bell.wav"
                      preload="auto"
                      className="hidden"
                    ></audio>
                    {audio && <audio src={audio} className="hidden"></audio>}
                  </div>
                </div>
                <div className="flex flex-col justify-center items-center w-full">
                  <h3
                    className="text-slate-200 text-base sm:text-lg tracking-widest mb-6 sm:mb-12 px-2"
                    style={{ letterSpacing: "0.3em" }}
                  >
                    JOINING INFORMATION
                  </h3>

                  <div className="flex flex-col gap-3 sm:gap-4 max-w-lg w-full">
                    <div>
                      <div className="w-full bg-black text-slate-100 border border-white/10 rounded-lg px-3 sm:px-4 py-2 flex items-center justify-between max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px]">
                        <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
                          <span className="text-slate-300 text-xs sm:text-sm whitespace-nowrap">
                            Room Name:
                          </span>
                          <span className="text-[#8B5CF6] font-medium truncate text-xs sm:text-sm max-w-[40vw] sm:max-w-[320px]">
                            {roomName}
                          </span>
                        </div>
                        <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
                          {copiedRoomName && (
                            <span className="text-xs text-[#8B5CF6] whitespace-nowrap">
                              Copied!
                            </span>
                          )}
                          <button
                            onClick={() => {
                              if (!copiedRoomName) {
                                copyRoomName();
                              }
                            }}
                            type="button"
                            title="Copy room name"
                            className="p-1.5 sm:p-1 rounded-md hover:bg-white/10 text-[#8B5CF6] touch-manipulation flex-shrink-0"
                          >
                            {!copiedRoomName && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="20"
                                height="20"
                                className=""
                                fill="none"
                              >
                                <path
                                  d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  opacity="0.4"
                                ></path>
                              </svg>
                            )}
                            {copiedRoomName && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width={20}
                                height={20}
                                className={""}
                                fill="none"
                                style={{ color: "#8B5CF6" }}
                              >
                                <path
                                  d="M22 11.1V6.9C22 3.4 20.6 2 17.1 2H12.9C9.4 2 8 3.4 8 6.9V8H11.1C14.6 8 16 9.4 16 12.9V16H17.1C20.6 16 22 14.6 22 11.1Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  opacity="0.4"
                                />
                                <path
                                  d="M16 17.1V12.9C16 9.4 14.6 8 11.1 8H6.9C3.4 8 2 9.4 2 12.9V17.1C2 20.6 3.4 22 6.9 22H11.1C14.6 22 16 20.6 16 17.1Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M6.08008 14.9998L8.03008 16.9498L11.9201 13.0498"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="relative">
                        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-4 h-4 sm:w-5 sm:h-5"
                          >
                            <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm-7 7a7 7 0 0 1 14 0 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"></path>
                          </svg>
                        </div>
                        <input
                          placeholder="Name *"
                          required
                          className={`w-full bg-white text-slate-900 rounded-md pl-9 sm:pl-10 pr-3 py-2.5 sm:py-3 shadow-sm focus:outline-none max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px] text-sm sm:text-base min-h-[44px] ${nameError ? "border-2 border-red-500" : ""
                            }`}
                          type="text"
                          value={userName}
                          onChange={(e) => {
                            setUserName(e.target.value);
                            if (nameError && e.target.value.trim() !== "") {
                              setNameError(false);
                            }
                          }}
                          onBlur={() => {
                            if (!userName || userName.trim() === "") {
                              setNameError(true);
                            } else {
                              setNameError(false);
                            }
                          }}
                        />
                        {nameError && (
                          <p className="text-red-500 text-sm mt-1">
                            Name is required
                          </p>
                        )}
                      </div>
                    </div>

                    {meetingRole === "moderator" && (
                      <div>
                        <div className="relative">
                          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              className="w-4 h-4 sm:w-5 sm:h-5"
                            >
                              <path d="M7 4V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h4a1 1 0 0 1 1 1v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a1 1 0 0 1 1-1h4Zm2-1v1h6V3H9ZM4 6v13h16V6H4Zm2 2h2v2H6V8Zm4 0h2v2h-2V8Zm4 0h2v2h-2V8Zm-8 4h2v2H6v-2Zm4 0h2v2h-2v-2Zm4 0h2v2h-2v-2Z"></path>
                            </svg>
                          </div>
                          <input
                            placeholder="Meeting Name"
                            className="w-full bg-white text-slate-900 rounded-md pl-9 sm:pl-10 pr-3 py-2.5 sm:py-3 shadow-sm focus:outline-none max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px] text-sm sm:text-base min-h-[44px]"
                            type="text"
                            value={customMeetingName}
                            onChange={(e) => {
                              setCustomMeetingName(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    )}

                    {meetingSettings && meetingSettings.requirePassword && (
                      <div className="flex flex-col items-center gap-3 mt-6 sm:mt-10 mb-2">
                        <p className="text-slate-300 text-sm sm:text-base mb-2 px-2 text-center">
                          Your password to join the room is:
                        </p>
                        <div className="flex gap-2 sm:gap-3 justify-center">
                          {passwordDigits.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) =>
                                (passwordInputRefs.current[index] = el)
                              }
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              maxLength="1"
                              value={digit}
                              onChange={(e) =>
                                handlePasswordInput(index, e.target.value)
                              }
                              onKeyDown={(e) => handlePasswordKeyDown(index, e)}
                              onPaste={handlePasswordPaste}
                              className={`w-10 h-10 sm:w-12 sm:h-12 bg-white text-slate-900 text-center text-lg sm:text-xl font-semibold rounded-lg border-2 focus:outline-none transition-colors ${passwordError
                                ? "border-red-500 focus:border-red-500"
                                : "border-gray-300 focus:border-blue-500"
                                }`}
                            />
                          ))}
                        </div>
                        {passwordError && (
                          <p className="text-red-500 text-sm mt-2">
                            Password is not correct
                          </p>
                        )}
                      </div>
                    )}

                    <div>
                      <div className="relative">
                        <h1 className="text-slate-300 text-sm  mb-4">
                          Join as:
                        </h1>
                        <div className="flex items-center bg-black border border-white/10 rounded-lg p-1 w-full max-w-full sm:max-w-[420px] md:min-w-[420px] md:max-w-[420px]">
                          <button
                            type="button"
                            disabled=""
                            className={`flex-1 px-3 sm:px-4 py-2.5 sm:py-2 rounded-md text-sm font-medium transition-all duration-200 text-slate-300 hover:text-white hover:bg-white/5 opacity-50 cursor-not-allowed touch-manipulation min-h-[44px] ${["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                              ? "bg-[#8B5CF6] text-white"
                              : ""
                              }`}
                          >
                            Moderator
                          </button>
                          <button
                            type="button"
                            disabled=""
                            className={`flex-1 px-3 sm:px-4 py-2.5 sm:py-2 rounded-md text-sm font-medium transition-all duration-200 text-white shadow-lg opacity-50 cursor-not-allowed touch-manipulation min-h-[44px] ${["moderator", "co-host", "speaker"].includes(
                              meetingRole
                            )
                              ? ""
                              : "bg-[#8B5CF6] text-white"
                              }`}
                          >
                            Participant
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-4 w-full justify-center mt-8 sm:mt-[50px] px-2">
                      <button
                        onClick={() => {
                          handleLaunchRoom();
                        }}
                        aria-label="Join Room"
                        className="bg-green-500 hover:bg-green-600 text-white font-medium py-3 sm:py-3 px-3 rounded-3xl transition-colors duration-200 shadow-lg text-base sm:text-lg w-full max-w-full sm:max-w-md touch-manipulation min-h-[48px]"
                      >
                        Join Room
                      </button>
                    </div>

                    <div className="mt-6 sm:mt-10 text-xs text-[#8C8C8C] w-full flex flex-col items-center justify-center px-2">
                      <p className="text-center">R-Link Email Support:</p>
                      <p className="mb-4 text-center">
                        <a href="mailto:support@r-link.com" className="">
                          support@r-link.com
                        </a>
                      </p>
                      <p></p>
                      <p className="text-xs sm:text-sm mt-1 text-center">
                        <a
                          href="https://r-link.com/terms-of-services"
                          className="underline"
                        >
                          Terms & Conditions
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Virtual Background Modal */}
      {showVirtualBackgroundModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-0">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowVirtualBackgroundModal(false)}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-[#060621] rounded-lg shadow-xl w-full max-w-md mx-auto border border-gray-600 max-h-[90vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-3 sm:p-4 border-b border-gray-600 flex-shrink-0">
              <h3 className="text-base sm:text-lg font-semibold text-white">
                Choose Virtual Background
              </h3>
              <button
                onClick={() => setShowVirtualBackgroundModal(false)}
                className="text-gray-400 hover:text-white transition-colors touch-manipulation p-1"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Blur Controls */}
            <div className="p-3 sm:p-4 border-b border-gray-600 flex-shrink-0">
              <div className="space-y-3 sm:space-y-4">
                {/* Blur Toggle */}
                <div className="flex items-center justify-between gap-2">
                  <span className="text-white text-xs sm:text-sm font-medium">
                    BLUR YOUR BACKGROUND
                  </span>
                  <div className="flex bg-gray-700 p-1 rounded">
                    <button
                      onClick={() => {
                        setBlurEnabled(false);
                        handleStartVirtualBackground("", false);
                      }}
                      className={`px-2 sm:px-3 py-1.5 sm:py-1 text-xs font-medium transition-colors touch-manipulation min-h-[36px] ${!blurEnabled
                        ? "bg-[#7700ff] text-white"
                        : "text-gray-400 hover:text-white"
                        }`}
                    >
                      OFF
                    </button>
                    <button
                      onClick={() => {
                        setBlurEnabled(true);
                        handleStartVirtualBackground("", true);
                      }}
                      className={`px-2 sm:px-3 py-1.5 sm:py-1 text-xs font-medium transition-colors touch-manipulation min-h-[36px] ${blurEnabled
                        ? "bg-[#7700ff] text-white"
                        : "text-gray-400 hover:text-white"
                        }`}
                    >
                      ON
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Background Options */}
            <div className="p-3 sm:p-4 flex-1 overflow-y-auto">
              <div className="space-y-3">
                <span className="text-white text-xs sm:text-sm font-medium">
                  BLUR YOUR BACKGROUND
                </span>
                <div className="grid grid-cols-2 gap-2 sm:gap-3">
                  {/* No Background Option */}
                  <button
                    onClick={() => {
                      handleStartVirtualBackground(null, false);
                      setShowVirtualBackgroundModal(false);
                    }}
                    className={`p-3 sm:p-4 rounded-lg border transition-colors touch-manipulation ${!selectedBackground
                      ? "border-[#7700ff] bg-[#7700ff]/10"
                      : "border-gray-600 hover:border-gray-500"
                      }`}
                  >
                    <div className="flex flex-col items-center gap-1.5 sm:gap-2">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-700 rounded-lg flex items-center justify-center">
                        <svg
                          className="w-5 h-5 sm:w-6 sm:h-6 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </div>
                      <span className="text-white text-xs text-center">
                        No Background
                      </span>
                    </div>
                  </button>

                  {/* Upload Image Option - Only show if user is authenticated */}
                  {isAuthenticated && (
                    <>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                        onChange={handleFileUpload}
                        disabled={uploadingBackground}
                        className="hidden"
                        id="virtual-background-upload-input-joining"
                      />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (!uploadingBackground && fileInputRef.current) {
                            fileInputRef.current.click();
                          }
                        }}
                        disabled={uploadingBackground}
                        className="p-3 sm:p-4 rounded-lg border-2 border-dashed border-[#7700ff] hover:border-[#7700ff]/80 transition-colors touch-manipulation cursor-pointer w-full disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <div className="flex flex-col items-center gap-1.5 sm:gap-2">
                          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-700 rounded-lg flex items-center justify-center">
                            {uploadingBackground ? (
                              <svg
                                className="animate-spin w-5 h-5 sm:w-6 sm:h-6 text-[#7700ff]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                            ) : (
                              <svg
                                className="w-5 h-5 sm:w-6 sm:h-6 text-[#7700ff]"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                              </svg>
                            )}
                          </div>
                          <div className="flex items-center gap-1">
                            <span className="text-white text-xs text-center">
                              {uploadingBackground
                                ? "UPLOADING..."
                                : "UPLOAD YOUR IMAGE"}
                            </span>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowImageSizeInfoDialog(true);
                              }}
                              className="text-gray-400 hover:text-[#7700ff] transition-colors"
                              title="Image size recommendations"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </button>
                    </>
                  )}
                </div>

                {/* Custom Backgrounds Section - Only show if user is authenticated and has custom backgrounds */}
                {isAuthenticated && customBackgrounds.length > 0 && (
                  <div className="mt-3 sm:mt-4">
                    <span className="text-white text-xs sm:text-sm font-medium">
                      YOUR CUSTOM BACKGROUNDS
                    </span>
                    <div className="grid grid-cols-2 gap-2 sm:gap-3 mt-2 sm:mt-3">
                      {customBackgrounds.map((background) => (
                        <div
                          key={
                            background._id ||
                            background.id ||
                            background.uniqueName
                          }
                          className="relative group"
                        >
                          <button
                            onClick={() => {
                              handleStartVirtualBackground(
                                background.url,
                                false
                              );
                              setShowVirtualBackgroundModal(false);
                            }}
                            className={`w-full rounded-lg overflow-hidden transition-colors touch-manipulation ${selectedBackground === background.url
                              ? "ring-2 ring-[#7700ff]"
                              : "hover:ring-2 hover:ring-gray-500"
                              }`}
                          >
                            <img
                              className="w-full h-16 sm:h-20 object-cover"
                              src={
                                background.url?.startsWith("http")
                                  ? background.url
                                  : `${process.env.REACT_APP_BASE_URL || ""}${background.url
                                  }`
                              }
                              alt={
                                background.originalName || "Custom background"
                              }
                              onError={(e) => {
                                logger("error", 
                                  "Failed to load image:",
                                  background.url
                                );
                                e.target.style.display = "none";
                              }}
                            />
                          </button>
                          <button
                            onClick={(e) =>
                              handleDeleteBackground(
                                background._id || background.id,
                                e
                              )
                            }
                            className="absolute top-1 right-1 p-1 bg-red-600 hover:bg-red-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity touch-manipulation"
                            title="Delete background"
                          >
                            <svg
                              className="w-3 h-3 sm:w-4 sm:h-4 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Default Background Images Grid */}
                <div className="grid grid-cols-2 gap-2 sm:gap-3 mt-3 sm:mt-4">
                  <span className="col-span-2 text-white text-xs sm:text-sm font-medium">
                    DEFAULT BACKGROUNDS
                  </span>
                  {backgroundImageUrls.map((background, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        handleStartVirtualBackground(background, false);
                        setShowVirtualBackgroundModal(false);
                      }}
                      className={`rounded-lg overflow-hidden transition-colors touch-manipulation ${selectedBackground === background
                        ? "ring-2 ring-[#7700ff]"
                        : "hover:ring-2 hover:ring-gray-500"
                        }`}
                    >
                      <img
                        className="w-full h-16 sm:h-20 object-cover"
                        src={background}
                        alt={`Background ${index + 1}`}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Size Info Dialog */}
      {showImageSizeInfoDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowImageSizeInfoDialog(false)}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-4 sm:p-6 w-full max-w-md mx-4 text-white shadow-xl">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base sm:text-lg font-semibold text-white">
                Recommended Image Sizes
              </h3>
              <button
                onClick={() => setShowImageSizeInfoDialog(false)}
                className="text-gray-400 hover:text-white transition-colors touch-manipulation"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="space-y-4">
              <p className="text-gray-300 text-sm">
                For optimal virtual background performance, we recommend using
                images with the following specifications:
              </p>

              <div className="bg-gray-800/50 rounded-lg p-3 sm:p-4 space-y-3">
                <div>
                  <h4 className="text-white font-medium mb-2 text-sm sm:text-base">
                    Recommended Dimensions:
                  </h4>
                  <ul className="text-gray-300 text-xs sm:text-sm space-y-1 ml-4 list-disc">
                    <li>Minimum: 1280 x 720 pixels (16:9 aspect ratio)</li>
                    <li>Optimal: 1920 x 1080 pixels (Full HD)</li>
                    <li>Maximum: 3840 x 2160 pixels (4K)</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-white font-medium mb-2 text-sm sm:text-base">
                    File Size:
                  </h4>
                  <ul className="text-gray-300 text-xs sm:text-sm space-y-1 ml-4 list-disc">
                    <li>Recommended: Under 5 MB</li>
                    <li>Maximum: 10 MB</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-white font-medium mb-2 text-sm sm:text-base">
                    Supported Formats:
                  </h4>
                  <p className="text-gray-300 text-xs sm:text-sm ml-4">
                    JPEG, PNG, GIF, WebP
                  </p>
                </div>
              </div>

              <p className="text-gray-400 text-xs italic">
                Note: Images with a 16:9 aspect ratio will provide the best
                results and prevent distortion.
              </p>
            </div>

            {/* Footer */}
            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowImageSizeInfoDialog(false)}
                className="px-4 py-2 rounded-lg bg-[#7700ff] text-white hover:bg-[#7700ff]/80 transition-colors touch-manipulation text-sm sm:text-base"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Background Confirmation Modal */}
      {showDeleteConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => {
              setShowDeleteConfirmModal(false);
              setBackgroundToDelete(null);
            }}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-4 sm:p-6 w-full max-w-md mx-4 text-white shadow-xl">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base sm:text-lg font-semibold text-white">
                Delete Background?
              </h3>
              <button
                onClick={() => {
                  setShowDeleteConfirmModal(false);
                  setBackgroundToDelete(null);
                }}
                className="text-gray-400 hover:text-white transition-colors touch-manipulation"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="mb-6">
              <p className="text-gray-300 text-sm sm:text-base">
                Are you sure you want to delete this background? This action
                cannot be undone.
              </p>
            </div>

            {/* Footer */}
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowDeleteConfirmModal(false);
                  setBackgroundToDelete(null);
                }}
                className="px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white hover:bg-gray-700/50 transition-colors touch-manipulation text-sm sm:text-base"
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteBackground}
                className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors touch-manipulation text-sm sm:text-base"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
